import { MemoryCache } from './memory-cache';

const memoryCache = new MemoryCache<string, unknown>();

export const clearCache = (key: string) => {
  memoryCache.delete(key);

  localStorage.removeItem(key);
};

export const getCache = <T = any>(key: string) =>
  memoryCache.getOrSet(key, () => {
    const value = localStorage.getItem(key);
    if (value === null || value === '') return null;

    try {
      return JSON.parse(value);
    } catch {
      clearCache(key);
      return null;
    }
  }) as T;

export const setCache = <T = any>(key: string, value: T) => {
  if (value === null || value === undefined) {
    clearCache(key);
    return;
  }

  memoryCache.set(key, value);

  try {
    const cacheStr = JSON.stringify(value);
    localStorage.setItem(key, cacheStr);
  } catch {
    clearCache(key);
  }
};
